import { store } from "../redux/store";
import { post, get, getFullUrlWithParams, getFullResponse } from "./https";
import * as accountAction from "../redux/action/accountAction";
import * as requestAction from "../redux/action/requestAction";

export interface KbResult {
  response: {
    payStatus?: string;
    list?: any[];
    [propName: string]: any;
  };
  success: boolean;
  status: {
    code: string;
    describe: string;
  };
}
const alipayAccount = "2021002142612513";

export async function modifyLocalWebServer(
  id: string,
  ip: string,
  port: number
): Promise<KbResult> {
  const uri = `/website/modify/address/${id}`;
  const resp = await get(uri, `ip=${ip}&port=${port}`);
  return resp;
}

/**
 * 注册
 * @param data
 * @returns
 */
export async function regist(data: FormData) {
  const uri = "/user/regist";
  const resp = await post(uri, data);
  if (resp.success) {
    const { token, user } = resp.response;
    store.dispatch(accountAction.setLoginUser(user));
    store.dispatch(accountAction.setJwt(token));
    return true;
  } else {
    alert(resp.status.describe);
    return false;
  }
}

/**
 * 向邮箱发送验证码
 * @param email
 */
export async function sendVCode(email: string) {
  const uri = "/user/sendVCode";
  get(uri, `email=${email}`);
}

/**
 * 申请新的web通道
 * @param data
 * @returns
 */
export async function applyNewWebsiteChannel(
  data: FormData
): Promise<KbResult> {
  const uri = "/website/apply";
  const resp = await post(uri, data);
  return resp;
}

/**
 * 通用文件上传
 * @param data
 * @returns
 */
export async function uploadFile(data: FormData): Promise<any> {
  const uri = "/dfs/api/upload";
  const resp = await post(uri, data);
  return resp;
}

/**
 * 配置自定义域名
 * @param hostname
 * @returns
 */
export async function configureHostname(
  id: number,
  hostname: string
): Promise<KbResult> {
  const uri = `/website/config/hostname/${id}`;
  const resp = await get(uri, `hostname=${hostname}`);
  return resp;
}

/**
 * 申请新的web通道
 * @param data
 * @returns
 */
export async function deleteWebsiteChannel(id: number): Promise<KbResult> {
  const uri = `/website/delete/${id}`;
  const resp = await get(uri);
  return resp;
}

/**
 * 请求安装数字证书
 * @param channelId
 * @returns
 */
export async function requestOrRenewCert(channelId: number): Promise<KbResult> {
  const uri = `/website/requestOrRenewCert/${channelId}`;
  const resp = await get(uri);
  return resp;
}

/**
 * 发送客户端软件到邮箱
 * @param channelId
 * @returns
 */
export async function sendZhumiLinkToMail(
  packageName: string
): Promise<KbResult> {
  const uri = `/rdp/sendPackage/${packageName}`;
  const resp = await get(uri);
  return resp;
}

/**
 * 删除web通道
 * @param data
 * @returns
 */
export async function getClientHostedWebsites(
  clientId: string
): Promise<KbResult> {
  const uri = `/website/of/${clientId}`;
  const resp = await get(uri);
  return resp;
}

/**
 * 手动授权
 * @param id
 * @returns
 */
export async function authSync(id: number): Promise<KbResult> {
  const uri = `/rdp/auth/sync/${id}`;
  const resp = await get(uri);
  return resp;
}

/**
 * 登录
 * @param data
 * @returns
 */
export async function login(data: FormData) {
  const uri = "/user/login?mobile=" + data.get("mobile");
  const resp = await post(uri, data);
  if (resp.success) {
    const { token, user } = resp.response;
    store.dispatch(accountAction.setLoginUser(user));
    store.dispatch(accountAction.setJwt(token));
    return true;
  } else {
    store.dispatch(requestAction.warning(resp.status.describe));
    return false;
  }
}

/**
 * 申请新的RDP通道
 * @param data
 * @returns
 */
export async function applyRdpChannel() {
  const uri = "/rdp/applyRdpChannel";
  const resp = await post(uri);
  return resp as KbResult;
}

/**
 * 获取我的rdp列表
 * @param data
 * @returns
 */
export async function getMyRdpChannels(): Promise<KbResult> {
  const uri = "/rdp/list";
  const resp = await post(uri);
  return resp;
}

/**
 * 更新标签
 * @param data
 * @returns
 */
export async function updateTag(id: string, tag: string) {
  const uri = `/rdp/updateTag/${id}`;
  const resp = await get(uri, `tag=${tag}`);
  return resp as KbResult;
}

/**
 * 打开远程桌面
 * @param command 远程桌面命令
 * @param server  服务器地址
 */
export async function openRDP(server: string, port: string) {
  const url = `http://127.0.0.1:4321/system/exec?server=${server}&port=${port}`;
  try {
    await getFullUrlWithParams(url);
  } catch (err) {
    console.error(err);
    store.dispatch(
      requestAction.notify({
        type: "warning",
        text: "本地需先安装zhumi.link，请点击旁边的按钮：客户端下载。下载并运行！",
      })
    );
  }
}
/**
 * 生成支付订单
 * @param outBizNo      业务记录单号
 * @param productName   产品名称
 * @param orderType     订单类型
 * @param amount        订单金额
 * @param quantity      购买数量
 * @returns
 */
export async function generatePayOrder(
  outBizNo: string,
  productName: string,
  orderType: string,
  amount: number,
  quantity: number
) {
  const uri = `/alipay/web/${alipayAccount}/pay_order`;
  const params = `totalAmount=${amount}&orderType=${orderType}&body=${productName}&osType=web&outBizNo=${outBizNo}&quantity=${quantity}`;

  return await getFullResponse(uri, params);
}

/**
 * 查询支付状态(轮询调用)
 * @param outTradeNo
 * @returns
 */
export async function queryPayOrderStatus(outTradeNo: string) {
  const uri = `/alipay/web/${alipayAccount}/trade_query`;
  const params = `outTradeNo=${outTradeNo}`;

  return (await get(uri, params)) as KbResult;
}

/**
 * 处理支付宝同步返回的状态
 * @param outTradeNo
 * @returns
 */
export async function processReturnInfo(params: string) {
  const uri = `/alipay/web/${alipayAccount}/return_url`;

  return (await get(uri, params)) as KbResult;
}
